import { defineStore } from 'pinia'
import { SearchKoyouKeiyakuReq } from "@/types/KoyouKeiyaku"
import OptionConst from '@/const/Option'
import { cloneDeep } from 'lodash'

interface KoyouKeiyakuSearchState {
  condition: SearchKoyouKeiyakuReq,
}

const initValues = {
  koyou_keiyaku_id: null,
  staff_code: null,
  staff_name: null,
  staff_kana: null,
  mst_buka_id: null,
  mst_syuugyou_basyo_id: null,
  shinsei_type: [],
  koyou_type: [],
  keitai_type: [],
  syounin_status_type: [],
  honnin_status_type: [],
  searchType: OptionConst.KEIYAKU_SEARCH_TYPE.FREE,
  includeSakujo: false
}

export const useKoyouKeiyakuSearchStore = defineStore('koyoukeiyaku', {
  state: (): KoyouKeiyakuSearchState => ({
    condition: cloneDeep(initValues),
  }),
  actions: {
    async init() {
      this.condition = cloneDeep(initValues)
    },
    async reset() {
      const searchType = this.condition.searchType
      this.condition = cloneDeep(initValues)
      this.condition.searchType = searchType
    }
  }
})